import styled from "@emotion/styled";

export const Bar = styled("div", {
  shouldForwardProp: (prop) => prop !== "$writeMode" && prop !== "$expanded"
})<{ $writeMode: boolean; $expanded: boolean }>`
  position: fixed;
  top: calc(env(safe-area-inset-top, 0px) + 8px);
  left: 50%;
  transform: translate(calc(-50% + var(--drag-x, 0px)), var(--drag-y, 0px));
  z-index: 999999998;
  max-width: calc(100vw - 32px);
  padding: 0.375rem 0.75rem 0.375rem 0.375rem;
  border-radius: ${({ $expanded }) => ($expanded ? "16px" : "999px")};
  font-family: system-ui, sans-serif;
  font-size: 12px;
  line-height: 1.4;
  color: ${({ $writeMode }) => ($writeMode ? "#fff" : "#78350f")};
  background: ${({ $writeMode }) => ($writeMode ? "#b91c1c" : "#fef3c7")};
  border: 1px solid ${({ $writeMode }) => ($writeMode ? "#7f1d1d" : "#f59e0b")};
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.18);
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  white-space: nowrap;
`;

export const DragHandle = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  min-height: 28px;
  cursor: grab;
  touch-action: none;
  user-select: none;
  opacity: 0.6;

  &:active {
    cursor: grabbing;
  }
`;

export const ModeBadge = styled.strong`
  text-transform: uppercase;
  letter-spacing: 0.04em;
`;

export const UserId = styled.span`
  font-family: ui-monospace, monospace;
`;

const PillButton = styled.button`
  min-height: 28px;
  padding: 0 0.75rem;
  border: 1px solid currentColor;
  border-radius: 999px;
  background: transparent;
  color: inherit;
  font: inherit;
  font-weight: 600;
  cursor: pointer;
`;

export const BlockedToggle = styled(PillButton)`
  font-weight: 500;
`;

export const ExitButton = PillButton;

export const ConfirmButton = PillButton;

export const ConfirmRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem;
  margin: 0.5rem 0 0.25rem 1.75rem;
  font-weight: 600;
`;

export const BlockedList = styled.ol`
  max-height: 240px;
  margin: 0.5rem 0 0.25rem 1.75rem;
  padding: 0;
  overflow-y: auto;
  list-style: none;
  font-family: ui-monospace, monospace;
  font-size: 11px;

  li {
    margin: 0;
    padding: 0.125rem 0;
    font-size: inherit;
    line-height: 1.4;
    white-space: nowrap;
  }
`;
